

import type { ParameterTableMap, ResultMasterMap, ResultParameterTableResponse } from "@/interfaces/table-master";
import type { components } from "@/types/maestros-api";

type MasterResponse = components["schemas"]["MasterResponse"];

export const mapToTableMasterOfResponse = (
  { datos }: MasterResponse
): ResultMasterMap[] => {
  return (datos ?? []).map(
    ({ codigo, descripcion, registros }) => ({
      code: codigo ?? 0,
      description: descripcion ?? '',
      records: (registros ?? []).map(
        ({ codigo, valor, valorCadenaLargo }) => ({
          code: codigo ?? 0,
          value: valor ?? '',
          longStringValue: valorCadenaLargo ?? ''
        })
      )
    })
  )
};


export const mapToParameterTable = (
  resultParameter: ResultParameterTableResponse
): ParameterTableMap[] => {
  return resultParameter.datos.map((item) => ({
    code: item.codigo,
    numericValue: item.valorNumerico,
    stringValue: item.valorCadena,
    description: item.descripcion,
  }));
};
